module.exports = {
          srcSet: __webpack_public_path__ + "513596ea73a31afe1cd8562c0842c7b3-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "513596ea73a31afe1cd8562c0842c7b3-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "513596ea73a31afe1cd8562c0842c7b3-24.png",
          toString:function(){return __webpack_public_path__ + "513596ea73a31afe1cd8562c0842c7b3-24.png"},
          
          width: 24,
          height: 24
        }